// Home — bounce to /orders (the canonical landing page).

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/orders' });
  },
});
